// src/components/Dashboard/CreditScoreGauge.js

import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import Styles from "../../styles/_global/Styles";

function getRiskStyle(risk) {
  switch (risk) {
    case "Very High risk":
      return Styles.CreditScoreGauge.veryHighRisk;
    case "High risk":
      return Styles.CreditScoreGauge.highRisk;
    case "Medium High risk":
      return Styles.CreditScoreGauge.mediumHighRisk;
    case "Medium risk":
      return Styles.CreditScoreGauge.mediumRisk;
    case "Medium Low risk":
      return Styles.CreditScoreGauge.mediumLowRisk;
    case "Low risk":
      return Styles.CreditScoreGauge.lowRisk;
    case "Very Low risk":
      return Styles.CreditScoreGauge.veryLowRisk;
    default:
      return Styles.CreditScoreGauge.mediumRisk;
  }
}

export default function GaugeValueRangeNoSnap(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const score = props.score || 0;
  const risk = props.risk || "Low risk";
  let riskStyle = getRiskStyle(risk);

  if (!riskStyle) {
    riskStyle = {
      fontSize: 24,
      valueFillColor: "red",
      referenceFillColor: { xs: "rgba(255,255,255,0.3)", md: "#f9f9f9" },
    };
  }

  const referenceFill = isMobile
    ? riskStyle.referenceFillColor.xs
    : riskStyle.referenceFillColor.md;

  const gradientId = `gauge-gradient-${risk.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <svg width={0} height={0}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={Styles.primary.main} />
            <stop offset="100%" stopColor={riskStyle.valueFillColor} />
          </linearGradient>
        </defs>
      </svg>

      <Gauge
        width={props.width || 160}
        height={props.height || 160}
        value={score}
        valueMin={0}
        valueMax={1000}
        sx={{
          [`& .${gaugeClasses.valueArc}`]: {
            fill: `url(#${gradientId})`,
          },
          [`& .${gaugeClasses.referenceArc}`]: {
            fill: referenceFill,
          },
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: isMobile ? "2rem" : `${riskStyle.fontSize}px`,
            fill: isMobile ? "#fff" : riskStyle.valueFillColor,
          },
          ...(isMobile && {
            // add opaque white border on mobile arcs
            [`& .${gaugeClasses.valueArc}`]: {
              stroke: "rgba(255,255,255,0.2)",
              strokeWidth: 0.5,
            },
            [`& .${gaugeClasses.referenceArc}`]: {
              stroke: "rgba(255,255,255,0.2)",
              strokeWidth: 0.5,
            },
          }),
          ...(isMobile && {
            // ensure SVG text fallback is white and large
            "& svg text": {
              fontSize: "2rem",
              fill: "#fff !important",
            },
          }),
        }}
      />

      <Typography
        variant="body2"
        sx={{
          mt: 1,
          backgroundColor: riskStyle.valueFillColor,
          color: "#fff",
          px: 2,
          py: 0.5,
          borderRadius: "30px",
        }}
      >
        {risk}
      </Typography>
    </Box>
  );
}
